import React from 'react';
import { connect } from 'react-redux';
import { Button, IconButton } from 'react-toolbox/lib/button';
import { Checkbox } from 'react-toolbox';
import { get as getAction, create, remove, update } from '~/actions/actions';
import { get } from 'lodash';
import Spinner from '~/components/Spinner';
import UserPicker from '~/components/UserPicker';
import OrderPicker from '~/components/OrderPicker';
import ContainerPicker from '~/components/ContainerPicker';
import ArticlePicker from '~/components/ArticlePicker';
import LocationPicker from '~/components/LocationPicker';
import TaskPicker from '~/components/TaskPicker';
import MultiPicker from '~/components/MultiPicker';
import MultiPickerCount from '~/components/MultiPickerCount';
import styleDialog from '~/style/dialog.scss';
import styleLocal from './style.scss';

const types = {
  container_pick: {
    label: 'Container: pick articles',
    fields: [
      { id: 'name', label: 'name', type: 'text', required: true },
      { id: 'locationFrom', label: 'Location of containers', type: 'locationId', required: true },
      { id: 'locationTo', label: 'Location to move to', type: 'locationId', required: true },
      { id: 'locationPick', label: 'Location of warehouse', type: 'locationId', required: true },
    ],
    onSubmit: (_this, values) => create(_this.props.dispatch, _this.context.apiClient, values.name, 'container_pick', { locationFrom: values.locationFrom, locationTo: values.locationTo, locationPick: values.locationPick }),
  },
  container_verify: {
    label: 'Container: verify articles',
    fields: [
      { id: 'name', label: 'name', type: 'text', required: true },
      { id: 'locationFrom', label: 'Location of containers', type: 'locationId', required: true },
      { id: 'locationSuccess', label: 'Location to move on success', type: 'locationId', required: true },
      { id: 'locationFail', label: 'Location to move on fail', type: 'locationId', required: true },
      { id: 'locationDiff', label: 'Location of warehouse', type: 'locationId', required: true },
    ],
    onSubmit: (_this, values) => create(_this.props.dispatch, _this.context.apiClient, values.name, 'container_verify', { locationFrom: values.locationFrom, locationDiff: values.locationDiff, locationSuccess: values.locationSuccess, locationFail: values.locationFail }),
  },
  container_shipping_set: {
    label: 'Container: set shipping',
    fields: [
      { id: 'name', label: 'name', type: 'text', required: true },
      { id: 'locationFrom', label: 'Location of containers', type: 'locationId', required: true },
      { id: 'locationTo', label: 'Location to move to', type: 'locationId', required: true },
    ],
    onSubmit: (_this, values) => create(_this.props.dispatch, _this.context.apiClient, values.name, 'container_shipping_set', { locationFrom: values.locationFrom, locationTo: values.locationTo }),
  },
  container_move: {
    label: 'Container: move',
    fields: [
      { id: 'name', label: 'name', type: 'text', required: true },
      { id: 'locationFrom', label: 'Location of containers', type: 'locationId', required: true },
      { id: 'locationTo', label: 'Location to move to', type: 'locationId', required: true },
    ],
    onSubmit: (_this, values) => create(_this.props.dispatch, _this.context.apiClient, values.name, 'container_move', { locationFrom: values.locationFrom, locationTo: values.locationTo }),
  },
  container_empty: {
    label: 'Container: empty',
    fields: [
      { id: 'name', label: 'name', type: 'text', required: true },
      { id: 'locationFrom', label: 'Location of containers', type: 'locationId', required: true },
      { id: 'locationTo', label: 'Location to move to', type: 'locationId', required: true },
    ],
    onSubmit: (_this, values) => create(_this.props.dispatch, _this.context.apiClient, values.name, 'container_empty', { locationFrom: values.locationFrom, locationTo: values.locationTo }),
  },
  order_pick: {
    label: 'Order: pick',
    fields: [
      { id: 'name', label: 'name', type: 'text', required: true },
      { id: 'locationFrom', label: 'Location of containers', type: 'locationId', required: true },
      { id: 'locationTo', label: 'Location to move when finished', type: 'locationId', required: false },
      { id: 'locationPick', label: 'Location of warehouse', type: 'locationId', required: true },
    ],
    onSubmit: (_this, values) => create(_this.props.dispatch, _this.context.apiClient, values.name, 'order_pick', { locationFrom: values.locationFrom, locationTo: values.locationTo, locationPick: values.locationPick }),
  },
};

const fields = {
  orderId: OrderPicker,
  containerId: ContainerPicker,
  userId: UserPicker,
  userIds: MultiPicker(UserPicker),
  articleId: ArticlePicker,
  articleIds: MultiPickerCount(ArticlePicker),
  taskIds: MultiPicker(TaskPicker),
  locationId: LocationPicker,
  taskId: TaskPicker,
  text: ({ onChange, ...props }) => <input {...props} onChange={e => onChange(e.target.value)} />,
};


class Dialog extends React.Component {
  static contextTypes = {
    dialogPush: React.PropTypes.func.isRequired,
    dialogClose: React.PropTypes.func.isRequired,
    apiClient: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: !!props.data.id,
    };
  }

  componentDidMount() {
    if (this.props.data.id) {
      getAction(this.props.dispatch, this.context.apiClient, this.props.data.id)
        .then(r => this.setState({ item: r.data, userIds: r.data.userIds, loading: false }));
    }
  }

  onFormSubmit(e) {
    e.preventDefault();
    const { type, loading, item: task, name, userIds, ...values } = this.state;
    const changes = {};
    if (name !== undefined) { changes.name = name; }
    if (type !== undefined) { changes.type = type; }
    if (userIds !== undefined) { changes.userIds = userIds; }
    if (values !== undefined && Object.keys(values).length > 0) { changes.data = values; }
    update(this.props.dispatch, this.context.apiClient, task.id, changes)
      .then(() => this.context.dialogClose(this.props.dialogId));
  }

  remove() {
    return remove(
      this.props.dispatch,
      this.context.apiClient,
      this.props.data.id
    ).then(() => this.context.dialogClose(this.props.dialogId));
  }

  toggleUserId(userId, add) {
    let userIds = get(this.state, 'userIds', []);
    if (add) {
      userIds.push(userId);
    } else {
      userIds = userIds.filter(id => id !== userId);
    }
    this.setState({ userIds });
  }

  renderCreate() {
    return (
      <div style={{ padding: '10px' }}>
        <div style={{ marginBottom: '10px' }}>New action - {types[this.state.type].label}</div>
        <form
          onSubmit={e => {
            e.preventDefault();
            const { type, loading, item, ...values } = this.state;
            types[this.state.type].onSubmit(
              this,
              values,
            );
            this.context.dialogClose(this.props.dialogId);
          }}
        >
          {(types[this.state.type] ? types[this.state.type].fields : []).map(field =>
            <div className={styleLocal.titleRow} key={field.id}>
              {field.label && <div className={styleLocal.title}>
                {field.label}
                {field.required && <div className={styleLocal.required}>*</div>}
              </div>}
              <div className={styleLocal.value}>
                {(() => {
                  const Cmp = fields[field.type];
                  return Cmp ? <Cmp
                    key={field.id}
                    id={field.id}
                    value={this.state[field.id]}
                    required={field.required}
                    onChange={v => this.setState({ [field.id]: v })}
                  /> : `Unknown field type "${field.type}"`;
                })()}
              </div>
            </div>)}
          <Button primary raised type="submit" label="Create action" style={{ marginTop: '10px' }} />
        </form>
      </div>
    );
  }

  renderUpdate() {
    const task = this.state.item;
    const userIds = get(this.state, 'userIds', []);
    return (
      <div style={{ padding: '10px' }}>
        <div style={{ marginBottom: '10px' }}>Update action #{task.sku} - {types[task.type] ? types[task.type].label : 'Unknown type'}</div>
        <form onSubmit={e => this.onFormSubmit(e)}>
          {(types[task.type] ? types[task.type].fields : []).map(field =>
            <div className={styleLocal.titleRow} key={field.id}>
              {field.label && <div className={styleLocal.title}>
                {field.label}
                {field.required && <div className={styleLocal.required}>*</div>}
              </div>}
              <div className={styleLocal.value}>
                {(() => {
                  const Cmp = fields[field.type];
                  return Cmp ? <Cmp
                    key={field.id}
                    id={field.id}
                    value={this.state[field.id] !== undefined
                      ? this.state[field.id]
                      : task[field.id] || (task.data || {})[field.id]
                    }
                    required={field.required}
                    onChange={v => this.setState({ [field.id]: v })}
                  /> : `Unknown field type "${field.type}"`;
                })()}
              </div>
            </div>)}
          <div className={styleLocal.titleRow}>
            <div className={styleLocal.title}>Permitted users</div>
            <div className={styleLocal.value}>
              <Checkbox
                label="All users permitted"
                checked={userIds.includes('all')}
                onChange={val => this.toggleUserId('all', val)}
              />
              {!userIds.includes('all') && (() => {
                const Cmp = fields.userIds;
                return <Cmp value={userIds} onChange={v => this.setState({ userIds: v })} />;
              })()}
            </div>
          </div>
          <div style={{ marginTop: '10px' }}>
            <Button primary raised type="submit" label="Save action" />
            <Button
              className={styleLocal.buttonRemove}
              label="Delete"
              icon="clear"
              onClick={() => this.context.dialogPush('message', { content: 'Are you sure?', onConfirm: () => this.remove() })}
            />
          </div>
        </form>
      </div>
    );
  }

  renderContent() {
    if (this.state.loading) {
      return (
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <Spinner style={{ display: 'inline-block' }} />
        </div>
      );
    }
    if (this.props.data.id && !this.state.item) {
      return (
        <div style={{ textAlign: 'center', padding: '20px' }}>
          Action not found
        </div>
      );
    }
    if (this.props.data.id) {
      return this.renderUpdate();
    }
    if (!this.state.type) {
      return (
        <div style={{ padding: '10px' }}>
          <div>Select the type of action</div>
          {Object.keys(types).map(type => <Button
            key={type}
            style={{ width: '100%', marginTop: '10px' }}
            className={styleLocal.buttonOutline}
            label={types[type].label}
            onClick={() => this.setState({ type })}
          />)}
        </div>
      );
    }
    return this.renderCreate();
  }

  render() {
    return (
      <div className={[styleDialog.background, styleDialog[this.props.transition]].join(' ')} onClick={() => this.context.dialogClose(this.props.dialogId)}>
        <div className={styleDialog.container} onClick={e => e.stopPropagation()}>
          <IconButton className={styleDialog.closeButton} icon="close" onClick={() => this.context.dialogClose(this.props.dialogId)} />
          <div className={styleDialog.content}>
            {this.renderContent()}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(Dialog);



// WEBPACK FOOTER //
// ./app/dialogs/ActionNew/index.js